/<template lang="pug">
  .container-dialog(id="SetPlayListItemPlayerExceptions-container")
    el-form(v-on:submit.native.prevent="savePlayersExeptions()",
      :model="playExeptions",
      ref="playExeptions",
      label-width="120px",
    )
        el-input.search-input(
          id="SetPlayListItemPlayerExceptions-searchInput",
          size="mini",
          v-model="searchString",
          clearable
        )
          i.el-icon-search.el-input__icon(slot='suffix')
        el-switch.float-right(v-model='visibleFormPlayOnly', :active-text='$t("Play only on")', :inactive-text='$t("Do not play on")')

        .player-row(
          v-for="localPlayList in localPlayListsWithPlayItemFiltered()",
          v-if='visibleFormPlayOnly',
          @click='togglePlayOnly(localPlayList)',
          :class='{ selected: getSelectedPlayOnly(localPlayList) }'
        )
          span.name {{ localPlayList.fullNameOfDesktopPlaylist }}

        .player-row(
          v-for="localPlayList in localPlayListsWithPlayItemFiltered()",
          v-if='!visibleFormPlayOnly',
          @click='toggleForbidden(localPlayList)',
          :class='{ selected: getSelectedPlayForbidden(localPlayList) }'
        )
          span.name {{ localPlayList.fullNameOfDesktopPlaylist }}
    br
    br
    el-button.float-right(
      id="SetPlayListItemPlayerExceptions-submitButton"
      type="success",
      :disabled="isSaving",
      size='mini',
      @click="savePlayersExeptions()",
    )
      font-awesome-icon(icon="save")
      span &nbsp; {{$t(buttonSaveText())}}
    .errors(v-if="errors.length > 0")
      .error(v-for="error in errors")
        p {{ error }}
    br
</template>

<script>
import Vue from 'vue'
import textUtils from './../Common/textUtils.mixin'

export default {
  props: ['playListItem', 'playList'],
  mixins: [textUtils],
  async created () {
    await this.loadData()
    if (this.playListItem.playOnlyInMedia && JSON.parse(this.playListItem.playOnlyInMedia).length > 0) this.visibleFormPlayOnly = true
  },
  mounted () {
  },
  data () {
    return {
      errors: [],
      playExeptions: {
        playOnlyInMedia: this.playListItem.playOnlyInMedia ? JSON.parse(this.playListItem.playOnlyInMedia) : [],
        playForbiddenInMedia: this.playListItem.playForbiddenInMedia ? JSON.parse(this.playListItem.playForbiddenInMedia) : []
      },
      localPlayListsWithPlayItem: undefined,
      visibleFormPlayOnly: false,
      isSaving: false,
      searchString: ''
    }
  },
  methods: {
    togglePlayOnly (localPlayList) {
      const index = this.playExeptions.playOnlyInMedia.findIndex(poim => poim === localPlayList.id)
      if (index === -1) {
        this.playExeptions.playOnlyInMedia.push(localPlayList.id)
      } else {
        this.playExeptions.playOnlyInMedia.splice(index, 1)
      }
      this.playExeptions.playForbiddenInMedia = []
    },
    toggleForbidden (localPlayList) {
      const index = this.playExeptions.playForbiddenInMedia.findIndex(poim => poim === localPlayList.id)
      if (index === -1) {
        this.playExeptions.playForbiddenInMedia.push(localPlayList.id)
      } else {
        this.playExeptions.playForbiddenInMedia.splice(index, 1)
      }
      this.playExeptions.playOnlyInMedia = []
    },
    getSelectedPlayOnly (localPlayList) {
      const index = this.playExeptions.playOnlyInMedia.indexOf(localPlayList.id)
      return index > -1
    },
    getSelectedPlayForbidden (localPlayList) {
      const index = this.playExeptions.playForbiddenInMedia.indexOf(localPlayList.id)
      return index > -1
    },
    async loadData () {
      let playlistsFullPath = (await Vue.axios.post('medium/findPlaylistsAffectedFullPath', { 'Medium': this.playListItem.Medium.id })).data.occurrences
      let filteredLocalPlaylists = playlistsFullPath.filter(plfp => plfp.type === 'PlayListDesktop')
      for (let index = 0; index < filteredLocalPlaylists.length; index++) {
        filteredLocalPlaylists[index].PlayListDesktopName = filteredLocalPlaylists[index].path.split('/')[0]
      }

      // Narrow playlists to this playitem only
      filteredLocalPlaylists = filteredLocalPlaylists.filter(a => a.pathByPlaylistitemid.endsWith(`/${this.playListItem.id}`))

      // Now, we have local playlists (PlayListDesktop type)
      // its media with devicedesktops to assemble name
      // (it cannot be done from cache, as playlists are not in cache)
      // Also, cannot get required playlists, as Request may be too large
      this.localPlayListsWithPlayItem = []
      for (const localPlayList of filteredLocalPlaylists) {
        if (this.localPlayListsWithPlayItem.findIndex(lp => lp.id === localPlayList.id) === -1) {
          localPlayList.fullNameOfDesktopPlaylist = this.fullNameOfDesktopPlaylistById(localPlayList.id)
          this.localPlayListsWithPlayItem.push(localPlayList)
        }
      }
      this.localPlayListsWithPlayItem.sort((a, b) => a.fullNameOfDesktopPlaylist.localeCompare(b.fullNameOfDesktopPlaylist))
    },
    localPlayListsWithPlayItemFiltered () {
      if (this.searchString.length === 0) {
        return this.localPlayListsWithPlayItem
      } else {
        return this.localPlayListsWithPlayItem.filter(lp => lp.fullNameOfDesktopPlaylist.indexOf(this.searchString) > -1)
      }
    },
    buttonSaveText () {
      if (this.isSaving) return this.$t('saving...')
      return this.$t('Save exceptions')
    },
    __validateInput () {
      this.errors = []
      return true
    },
    async savePlayersExeptions () {
      if (!this.__validateInput()) return
      this.isSaving = true
      let path = `PlayListItem/${this.playListItem.id}`
      this.playExeptions.playOnlyInMedia = typeof this.playExeptions.playOnlyInMedia !== 'string' ? JSON.stringify(this.playExeptions.playOnlyInMedia) : this.playExeptions.playOnlyInMedia
      this.playExeptions.playForbiddenInMedia = typeof this.playExeptions.playForbiddenInMedia !== 'string' ? JSON.stringify(this.playExeptions.playForbiddenInMedia) : this.playExeptions.playForbiddenInMedia
      await Vue.axios.patch(path, this.playExeptions)
      this.isSaving = false
      this.$emit('close')
    }
  },
  computed: {
  }
}
</script>
<style lang="scss" scoped>
@import "../../../theme-m4b/src/common/var.scss";
.player-row {
  padding: 10px 10px;
  border-bottom:  $--border-light;
  cursor: pointer;
  color: $--color-text-secondary;
  font-size: $--font-size-small;
  display: flex;
  align-items: center;
  &.selected {
    font-weight: bold;
    color: $--color-text-primary;
    background-color:  $--background-color-selected;
  }
}
.search-input {
  width: 200px;
}
.container-dialog {
  width: 70%;
  margin: auto;
}
.name {
  font-size: $--font-size-base;
}
</style>



// WEBPACK FOOTER //
// src/components/Medium/SetPlayListItemPlayerExeptions.vue